<template lang="pug">
    v-autocomplete(dense 
        v-model="dataAccountType" 
        :disabled="disabled"
        :readonly="readonly" 
        :label="label" 
        :rules="rules"
        :items="listData" 
        item-text="description" 
        item-value="id" 
        @change="onSelect" 
        :required = "required")
</template>
<script>
export default {
    name: "FSelectAccountType",
    props: [
        "value",
        "disabled",
        "readonly",
        "label",
        "rules",
        "required"
    ],
    data() {
        return {
            dataAccountType: {},
            listData: []
        }
    },
    mounted() {
        this.doLoad();
        this.doInit(this.value);
    },
    watch: {
        value(val){
            this.doInit(val);
        }
    },
    methods: {
        doInit(values){
            this.dataAccountType = values ? values : null;
        },
        doLoad(){
            this.$http.get("/api/parameter/account-type").then(success => {
                this.listData = success.data;
            });
        },
        onSelect() {
            this.$emit("input", this.dataAccountType);
            this.$emit("select", this.dataAccountType);
            this.$emit("accountType", this.valueData());
        },
        valueData(){
            let result = null;
            this.listData.map(element => {
                if (this.dataAccountType === element.id) {
                    result = element;
                }
            });
            return result;
        },
    },
}
</script>